function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.36,
  filter: "url(#filter0_i)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M41.2928 13.4481C44.0179 13.2152 46.4202 15.1846 46.6586 17.8468L50.2226 57.6444C50.461 60.3066 48.4452 62.6536 45.7201 62.8865L16.1154 65.4169C13.3904 65.6498 10.988 63.6805 10.7496 61.0182L7.18565 21.2207C6.94724 18.5584 8.96305 16.2115 11.6881 15.9785L41.2928 13.4481Z",
  fill: "url(#paint0_linear)",
  fillOpacity: 0.6
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.36,
  filter: "url(#filter1_i)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.1191 20.8589H31.931V65.4356H17.2388C14.4113 65.4356 12.1191 63.1435 12.1191 60.316V20.8589Z",
  fill: "url(#paint1_linear)"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5957 15.953C14.5957 13.1916 16.8343 10.953 19.5957 10.953H59.1254C61.8868 10.953 64.1254 13.1916 64.1254 15.953V60.4357C64.1254 63.1971 61.8868 65.4357 59.1254 65.4357H19.5957C16.8343 65.4357 14.5957 63.1971 14.5957 60.4357V15.953Z",
  fill: "url(#paint2_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 22.0254,
  y: 25.8119,
  width: 34.6708,
  height: 2.97178,
  rx: 1.48589,
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 22.0254,
  y: 33.2413,
  width: 34.6708,
  height: 2.97178,
  rx: 1.48589,
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 22.0254,
  y: 40.6708,
  width: 15.8495,
  height: 2.97178,
  rx: 1.48589,
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.36,
  filter: "url(#filter2_i)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27 11H55V14.4402C55 15.8539 53.8539 17 52.4402 17H29.5598C28.1461 17 27 15.8539 27 14.4402V11Z",
  fill: "url(#paint3_linear)",
  fillOpacity: 0.05
}));

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 6,
  width: 29.7178,
  height: 9.90594,
  rx: 2.55982,
  fill: "url(#paint4_linear)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M24 8.55998C24 7.14623 25.1461 6.00016 26.5598 6.00016H51.158C52.5717 6.00016 53.7178 7.14623 53.7178 8.55998V13.3461C53.7178 14.7599 52.5717 15.9059 51.158 15.9059H26.5598C25.1461 15.9059 24 14.7599 24 13.3461V8.55998Z",
  fill: "url(#paint5_linear)"
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 13.4294,
  width: 29.7178,
  height: 2.47648,
  fill: "black"
}));

var _ref12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i",
  x: 2.04687,
  y: 13.4294,
  width: 48.1949,
  height: 52.0062,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -5.11964
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.55982
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 0.241667 0 0 0 0 0.241667 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_i",
  x: 6.99951,
  y: 20.8589,
  width: 24.9315,
  height: 44.5767,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -5.11964
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.55982
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 0.241667 0 0 0 0 0.241667 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_i",
  x: 21.8804,
  y: 11,
  width: 33.1196,
  height: 6,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -5.11964
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.55982
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 0.241667 0 0 0 0 0.241667 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 48.4404,
  y1: 37.7458,
  x2: 8.98176,
  y2: 41.2794,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#40E080"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#06AA48"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 14.1003,
  y1: 20.8589,
  x2: 18.2424,
  y2: 56.2966,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5EEA75",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#02BC4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 40.2916,
  y1: 54.3998,
  x2: 24.4795,
  y2: 4.41718,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2FD772"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#81F2AF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 29.8,
  y1: 11,
  x2: 29.8538,
  y2: 15.8345,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5EEA75",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#02BC4D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 38.8589,
  y1: 6,
  x2: 38.8589,
  y2: 15.9059,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#82E8AB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00DB58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 38.8589,
  y1: 3.68786,
  x2: 38.8589,
  y2: 15.9079,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD4D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC4BE"
})));

var SvgOrders = function SvgOrders(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 6,
    width: 30,
    height: 10
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _ref10)), _ref11), _ref12);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrders, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/orders.13f42a15.svg";
export { ForwardRef as ReactComponent };